import React, { useEffect, useContext ,useState} from "react";
import { Row, Col, Modal, Spin, message , Button, notification} from "antd";
import { Auth } from "../../utils/AuthContext";
import Firebase from '../../utils/firebaseConfig';
import Live2 from '../conferencias/Live2';
import '../../assets/css/sala2.css';



const ConferenciaUno =() =>{


        return (

        <>
        
        <div className="cuerpo">
            
            <Row align="">
                <Col xs={{span:20, offset:1}} md={{span:8, offset:1}} style={{textAlign:'left'}}>
                    <br />
                </Col>
                <Col xs={{span:20, offset:2}} md={{span:22, offset:1}}>
<p className="titulo_webinar" style={{textAlign:'center'}}><strong>Primer conferencia o panel</strong>
      </p>
</Col>
            <Col span={16} offset={4}>
            <div className="contenedor_video">
      <iframe className="video" src="https://www.youtube.com/embed/LtF2fsygvh8?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; allowfullscreen;" allowfullscreen="1"></iframe>
      </div>
              
            </Col>
            <Col span={24}>
                <br/>
            </Col>
<Col span={0} className="contenedor_comparte">
        <p className="text_azul_comparte">Compártenos tu experiencia utilizando</p>
        </Col>
      
            </Row>

            </div>

            <div>

            <Row>
                <Col span={20} offset={2}>
                <br /><br />
                </Col>
                
            </Row>
        </div>

        </>
        
    );

}

export default ConferenciaUno;

